import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TwitterLogo from './assets/logo-twitter.svg';
import './styles/twitterCard.scss';

export default class TwitterCard extends Component {

  render() {
    const { name, handle, profilePic, children, imgSrc } = this.props;

    return (
      <div className="twitter-card">
        <div className="twitter-card__header">
          <img className="twitter-card__header__profile-pic" src={profilePic} alt={name} />
          <div className="twitter-card__header__name-plate">
            <div className="twitter-card__header__name-plate__name">
              {name}
            </div>
            <div className="twitter-card__header__name-plate__handle">
              {handle}
            </div>
          </div>
          <div className="twitter-card__header__name-plate__bird">
            <img src={TwitterLogo} alt="Twitter" />
          </div>
        </div>
        <div className="twitter-card__tweet">
          { children }
        </div>
        <img className="twitter-card__image" src={imgSrc} alt="Tweet" />
      </div>
    );
  }
}

TwitterCard.propTypes = {
  name: PropTypes.string,
  profilePic: PropTypes.string,
  handle: PropTypes.string,
  children: PropTypes.string,
  imgSrc: PropTypes.string
};
